import React, {createRef} from 'react';
import clsx from "clsx";

export default function ShortText(props) {

    const labelRef = createRef();
    const sublabelRef = createRef();

    const data = props.data;

    return <div id={data.id} className={clsx('sendiio-form-short-text-element', `sendiio-form-label-alignment-${data.labelAlignment}`)}>
        <label ref={labelRef}
               className={clsx('sendiio-form-short-text-label', 'cursor-text', data.required && 'sendiio-form-element-required')}
               placeholder="Type a question"
               contentEditable={true}
               suppressContentEditableWarning={true}
               dangerouslySetInnerHTML={{__html: data.label}} />
        <div className="sendiio-form-element-wrapper">
            <input className="sendiio-form-short-text-input cursor-text"
                   type="text"
                   onChange={e => {e.preventDefault()}}
                   id={`input-${data.id}-short-text`}
                   name={`${data.id}-short-text`}
                   value="" />
            <p  ref={sublabelRef}
                className="sendiio-form-short-text-sublabel cursor-text"
                placeholder="Type a sublabel"
                format="text"
                contentEditable={true}
                suppressContentEditableWarning={true}
                dangerouslySetInnerHTML={{__html: data.sublabel}} />
        </div>
    </div>

}